'use client'

import React from 'react'
import {DefaultValues, FormProvider as ReactHookForm, useForm} from 'react-hook-form'
import {Mode} from 'react-hook-form'
import {ZodObject} from 'zod'

import {zodResolver} from '@hookform/resolvers/zod'

import {useFormControl, withFormControl} from './form-control'

interface FormProviderProps extends React.PropsWithChildren {
  data?: DefaultValues<any>
  schema?: ZodObject<any>
  resolver?: (...props: any[]) => any
  mode?: Mode
}

export const FormProvider = withFormControl((props: FormProviderProps) => {
  const formControl = useFormControl()
  const form = useForm({
    formControl,
    defaultValues: props.data,
    resolver: props.resolver
      ? props.resolver
      : props.schema
        ? zodResolver<any>(props.schema, {async: true}, {mode: 'async'})
        : undefined,
    mode: props.mode || 'onChange',
    reValidateMode: 'onChange',
  })

  return <ReactHookForm {...form}>{props.children}</ReactHookForm>
})
